import * as FirebaseAuth from "firebase/auth"
import { ReactNode, useState } from "react"

interface AccountLinkPanelProps {
  firebaseUser: FirebaseAuth.User
  onLinkWithGoogle: (user: FirebaseAuth.User) => void
  onLinkWithPhone: (user: FirebaseAuth.User) => void
  onUnlinkProvider: (user: FirebaseAuth.User, providerId: string) => void
}

export function AccountLinkPanel({ firebaseUser, onLinkWithGoogle, onLinkWithPhone, onUnlinkProvider }: AccountLinkPanelProps): ReactNode {
  const [open, setOpen] = useState(false)

  const hasGoogle = firebaseUser.providerData.some((p) => p.providerId === "google.com")
  const hasPhone = firebaseUser.providerData.some((p) => p.providerId === "phone")

  return (
    <div className="w-100" style={{ maxWidth: 400 }}>
      <button className="btn btn-sm btn-outline-secondary" onClick={() => setOpen((v) => !v)}>
        {open ? "▼ アカウント連携を閉じる" : "▶ アカウント連携"}
      </button>
      {open && (
        <div className="d-flex flex-column gap-2 mt-2">
          {hasGoogle ? (
            <button className="btn btn-outline-danger form-control" onClick={() => onUnlinkProvider(firebaseUser, "google.com")}>
              Google 連携を解除
            </button>
          ) : (
            <button className="btn btn-outline-dark form-control" onClick={() => onLinkWithGoogle(firebaseUser)}>
              Google アカウントを連携
            </button>
          )}
          {hasPhone ? (
            <button className="btn btn-outline-danger form-control" onClick={() => onUnlinkProvider(firebaseUser, "phone")}>
              電話番号連携を解除
            </button>
          ) : (
            <button className="btn btn-outline-success form-control" onClick={() => onLinkWithPhone(firebaseUser)}>
              電話番号を連携
            </button>
          )}
          <div id="recaptcha-container-link" />
        </div>
      )}
    </div>
  )
}
